import React from 'react';

const TableConfSection = () => (
  <div className='pageHead-tableConf wrapper'>
    <div className='pageHead-tableConf-tabs'>
      <ul className='tabs' role='tablist'>
        <li className='tabs-item active' role='presentation'><a className='tabs-item-link' href='#pendientes' role='tab' aria-controls='pendientes' data-toggle='tab' ng-click="seachQr = {'estasignacion': 'pendiente'}">Pendientes</a></li>
        <li className='tabs-item' role='presentation'><a className='tabs-item-link' href='#planificados' role='tab' aria-controls='planificados' data-toggle='tab' ng-click="seachQr = {'estasignacion': 'planificado'}">Planificados</a></li>
        <li className='tabs-item' role='presentation'><a className='tabs-item-link' href='#ejecutados' role='tab' aria-controls='ejecutados' data-toggle='tab' ng-click="seachQr = {'estasignacion': 'ejecutado'}">Ejecutados</a></li>
        <li className='tabs-item' role='presentation'><a className='tabs-item-link' href='#todos' role='tab' aria-controls='todos' data-toggle='tab' ng-click='seachQr = {}'>Todos</a></li>
      </ul>
    </div>
    <div className='pageHead-tableConf-pagCols'>
      <nav className='pag'>
        <p className='pag-label'><span>1</span><span> -</span><span> 5</span><span> de</span><span> 599</span></p>
        <div className='pag-arrows'><a className='btn btn-default pag-link' ><i className='ion-chevron-left' /></a><a className='btn btn-default pag-link' ><i className='ion-chevron-right' /></a></div>
      </nav>
      <button className='btn btn-default pageHead-tableConf-editCols' data-toggle='modal' data-target='#customColumns'><i className='ion-edit' /></button>
    </div>
  </div>
);

export default TableConfSection;



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Asignaciones/TableConfSection.js